import PropTypes from 'prop-types'

import CardRow from '../../../../../shared/components/Styled/Card/CardRow.jsx'
import CardCol from '../../../../../shared/components/Styled/Card/CardCol.jsx'
import FreelancePage from '../../../../../shared/components/Styled/Containers/FreelancePage.jsx'

import ClearanceManager from '../../../../components/Clearance/ClearanceManager.jsx'

import './Habilitations.scss'

export default function Habilitations({freelance}) {
  return (
    <FreelancePage className="p-5">
      <h2 className="text-center">Habilitations</h2>
      <CardRow justify="center">
        <CardCol>
          Renseignez ici les habilitations défense, radioprotection et autorisations d&apos;accès site du consultant.
        </CardCol>
      </CardRow>

      <ClearanceManager freelanceId={freelance.id}/>
    </FreelancePage>
  )
}

Habilitations.propTypes = {
  freelance: PropTypes.object.isRequired,
}
